import SpringButton from './SpringButton';
import VideoPlayer from './VideoPlayer';
import ClickMission from './ClickMission';
import CardContainer from './CardContainer';

interface NewLevelUnlockedCardProps {
  videoSrc: string;
  startRevealEvolutionVideo: VoidFunction;
}

const NewLevelUnlockedCard: React.FC<NewLevelUnlockedCardProps> = ({ videoSrc, startRevealEvolutionVideo }: NewLevelUnlockedCardProps) => {
  return (
    <SpringButton className='flex flex-1' onClick={startRevealEvolutionVideo}>
      <CardContainer hasBlueBorder>
        <p className='text-[32px] font-bold text-text-primary px-10 pt-10 pb-5'>New Level Unlocked</p>
        <div className='flex-1 overflow-hidden'>
          <VideoPlayer src={videoSrc} className='w-full h-full object-contain' />
        </div>
        <div className='px-10 pb-10'>
          <ClickMission title='click to reveal you evolution' isWhite={true} />
        </div>
      </CardContainer>
    </SpringButton>
  );
};

export default NewLevelUnlockedCard;
